<div class="flex items-center">
  <p-tag
    [value]="label()"
    [icon]="_icon()"
    class="!font-light [font-variant:small-caps] !text-opacity-70 {{
      color().text
    }} {{ color().background }} [&_.p-tag-icon]:!opacity-70"
    [pTooltip]="tooltip()"
    tooltipPosition="bottom"
    showDelay="750"
    [autoHide]="false"
  />
</div>
